import { State } from '../../../store/state';

export const metricConfigSelector = (state: State) => state.metrics_config.metricsConfig;
export const errorCodeSelector = (state: State) => state.user.errorCode;